import { Component, OnInit, ViewChild } from '@angular/core';
import { CalendarEvent, DAYS_OF_WEEK, EventColor } from 'calendar-utils';
import {
  Calendar,
  CalendarEventFormComponent,
  CalendarManagementComponent,
  CalendarSettingsComponent,
  CalendarEvent as cEvent,
  RouterService,
  ToolService,
} from 'projects/shared/src/public-api';

import { CalendarDateFormatter, CalendarView } from 'angular-calendar';
import { CustomDateFormatter } from '../custom-date-formatter.provider';
import { StateService } from 'projects/shared/src/public-api';
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
  ],
  standalone: false,
})
export class CalendarComponent implements OnInit {
  weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
  subs: Subscription[] = [];
  refresh = new Subject<void>();
  viewDate: Date = new Date();
  CalendarView = CalendarView;
  view: CalendarView;
  dayStartHour = 6;
  dayEndHour = 20;
  excludeDays: number[] = [0, 6];
  CALENDARVIEWKEY = 'CALENDARVIEW';
  filteredEvents: CalendarEvent[] = [];
  dbEvents: cEvent[] = []; // database model
  events: CalendarEvent[] = []; // npm calendar model

  constructor(
    public state: StateService,
    public tools: ToolService,
    private modalCtrl: ModalController,
    public routerService: RouterService
  ) {}

  async ngOnInit() {
    let viewFound = (await this.state.readFromSecureStorage(
      this.CALENDARVIEWKEY
    )) as any;
    this.view = viewFound ? viewFound : CalendarView.Month;

    this.subs.push(
      this.state.calendars$.subscribe((calendars) => {
        this.events = [];
        this.dbEvents = [];
        calendars
          .filter((x) => x.active)
          .forEach((calendar) => {
            this.dbEvents.push(...calendar.calendarEvents);
            calendar.calendarEvents.forEach((evt) => {
              this.events.push({
                id: evt.id,
                start: new Date(evt.startDate),
                end: new Date(evt.endDate),
                color: {
                  primary: calendar.borderColorHex,
                  secondary: calendar.backgroundColorHex,
                  secondaryText: calendar.textColorHex,
                },
                title: evt.name,
                allDay: false,
              });
            });
          });
        this.refresh.next();
        this.filteredEvents = this.events.filter((x) =>
          this.tools.datesAreSameDay(x.start, new Date())
        );
      })
    );
  }

  dayClickedOnCalendar({
    date,
    events,
  }: {
    date: Date;
    events: CalendarEvent[];
  }) {
    this.filteredEvents = events;
  }

  handleRefresh(event: any) {
    this.subs.push(
      this.state.loadCalendarEvents().subscribe((x) => {
        event.target.complete();
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((x) => x.unsubscribe());
  }

  async viewChanged(e: any) {
    this.view = e.detail.value;
    await this.state.saveToSecureStorage(this.CALENDARVIEWKEY, e.detail.value);
  }

  async handleEventClicked(event: CalendarEvent) {
    console.log(event.id);
    //currently only used by other views
    await this.openFormModal(event.id.toString());
  }

  async addButtonClicked() {
    await this.openFormModal(null);
  }

  async settingsButtonClicked() {
    const modal = await this.modalCtrl.create({
      component: CalendarManagementComponent,
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    /*if (role === 'confirm') {
       
      }*/
  }

  async openFormModal(id: string) {
    let eventToModify = id ? this.dbEvents.find((x) => x.id == id) : {};
    const modal = await this.modalCtrl.create({
      component: CalendarEventFormComponent,
      componentProps: {
        selectedEvent: eventToModify,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }
}
